import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Web3Service } from '../services/web3.service';

export const networkInterceptor: HttpInterceptorFn = (req, next) => {
  const web3Service = inject(Web3Service);
  const chainId = web3Service.chainId();

  if (chainId) {
    try {
      const isAbsolute = /^https?:\/\//i.test(req.urlWithParams);
      const url = isAbsolute 
        ? new URL(req.urlWithParams) 
        : new URL(req.urlWithParams, 'http://dummy.com');

      if (
        !url.searchParams.has('chainId') && 
        !url.searchParams.has('chainIds') && 
        !url.searchParams.has('network') &&
        !url.hostname.includes('thegraph.com')
      ) {
        url.searchParams.set('chainId', chainId.toString());
        const newUrlStr = isAbsolute ? url.toString() : url.pathname + url.search;
        const clonedReq = req.clone({ url: newUrlStr });
        return next(clonedReq);
      }
    } catch (e) {
      console.error('Network interceptor URL parse error', e);
    }
  }

  return next(req);
};
